import { render } from "./DomainItem.vue?vue&type=template&id=475d372a"
import script from "./DomainItem.vue?vue&type=script&lang=ts"
export * from "./DomainItem.vue?vue&type=script&lang=ts"
script.render = render

export default script